<template>
  <div class="container py-10 mx-auto px-1 sm:px-0">
    <h1 class="text-3xl sm:text-4xl font-bold">Collection Estimate</h1>
    <p class="mt-3 text-gray-700">
      Use this page to request an estimate for your Magic: The Gathering collection.
    </p>

    <form class="mt-6 space-y-4 max-w-lg">
      <div>
        <label class="block text-sm font-medium">Name</label>
        <input type="text" class="mt-1 w-full border rounded px-3 py-2" placeholder="Your name" />
      </div>
      <div>
        <label class="block text-sm font-medium">Email</label>
        <input type="email" class="mt-1 w-full border rounded px-3 py-2" placeholder="you@example.com" />
      </div>
      <div>
        <label class="block text-sm font-medium">Approximate Collection Size</label>
        <input type="number" class="mt-1 w-full border rounded px-3 py-2" placeholder="e.g., 1200 cards" />
      </div>
      <div>
        <label class="block text-sm font-medium">Additional Notes</label>
        <textarea class="mt-1 w-full border rounded px-3 py-2" rows="4" placeholder="Optional: sets, rarity mix, etc."></textarea>
      </div>
      <button type="button" class="bg-[#54586a] text-white px-4 py-2 rounded">
        Request Estimate
      </button>
    </form>
  </div>
</template>

<script setup>
// no script needed yet
</script>
